import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/shared/auth/guards/auth.guard';
import { SuccessComponent } from './modules/landing/component/success/success.component';
import { RejectComponent } from './modules/landing/component/reject/reject.component';

const routes: Routes = [
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),canActivate:[AuthGuard]},
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  { path: 'profile', loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule), canActivate:[AuthGuard]},
  { path: '', loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule) },
  { path: 'project', loadChildren: () => import('./modules/project/project.module').then(m => m.ProjectModule),canActivate:[AuthGuard] },
  { path: 'logout', loadChildren: () => import('./modules/logout/logout.module').then(m => m.LogoutModule) },
  { path: 'success', component:SuccessComponent },
  {path:'reject',component:RejectComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
